export default {
  'show-list': 'Liste',
  'show-map': 'Carte',
  'details': 'Détails',
  'route-link': 'Itinéraire',
  'route-link.detail': 'Calculer l\'itinérairee',
  'map': 'Carte',
  'has-boxes': 'Vente d\'emballages Hermès',
  'acceptsSuitcases': 'Dépôt de bagages',
  'back': 'Retour',

  'shoplist.info': {
    __html: 'Entrer ci-dessus le code postal, la ville et/ou la rue.'
  },

  'shoplist.no-reroute-shops': 'Aucun point relais dans la zone recherchée.',

  'business-hours.unknown': 'Horaires d\'ouverture non disponibles pour ce point relais.',
  'business-hours.closed': 'Fermé',

  'search': 'Chercher',
  'search.input-placeholder': 'Entrer l\'adresse, le code postal ou la villen',
  'search-criteria': 'Critères de recherche',
  'search.toggle-details': 'Recherche détaillée',
  'search-detail.intro': 'Les points relais affichés peuvent être limités aux critères suivants:',
  'search-detail.luggage.label': 'Dépôt de bagages',
  'search-detail.boxes.label': 'Vente d\'emballages Hermès',
  'search-detail.apply': 'Utiliser les filtress',
  'search-detail.close': 'Fermer',

  'error.no-shops': {
    __html: 'Aucun point relais dans la zone recherchée.'
  },

  'error.address-resolve-failed': 'L\'adresse indiquée n\'est pas valide.',
  'error.position-resolve-failed': 'L\'adresse indiquée n\'est pas valide.',

  'days.short.MON': 'Lu',
  'days.short.TUE': 'Ma',
  'days.short.WED': 'Me',
  'days.short.THU': 'Je',
  'days.short.FRI': 'Ve',
  'days.short.SAT': 'Sa',
  'days.short.SUN': 'Di',
  'days.full.MON': 'Lundi',
  'days.full.TUE': 'Mardi',
  'days.full.WED': 'Mercredi',
  'days.full.THU': 'Jeudi',
  'days.full.FRI': 'Vendredi',
  'days.full.SAT': 'Samedi',
  'days.full.SUN': 'Dimanche',
  'days.today': "Aujourd'hui",
  'days.tomorrow': 'Demain',

  'time.preposition.UNTIL': "jusqu'à",
  'time.preposition.BEFORE': 'avant',

  //paketParcelLock
  'search.paketParcelLock.note': 'Please note: ',
  'search.paketParcelLock.link-text': 'how it works',
  'search.paketParcelLock.link-url': 'https://www.myhermes.de/service/paketstation/',

  //paketParcelLock
  'details.benefits.paketParcelLock.list-1': 'Sending of parcels',
  'details.benefits.paketParcelLock.list-2': 'Online shop returns',
  'details.benefits.paketParcelLock.list-3': 'Send parcels fast and easy',
  'details.benefits.paketParcelLock.link-wrapper-text': 'For more Information please see ',
  'details.benefits.paketParcelLock.link-text': 'www.hamburgbox.de/faq',
  'details.benefits.paketParcelLock.link-url': 'http://www.hamburgbox.de/faq',

  //paketParcelLock
  'details.hint.paketParcelLock.headline': 'Important note:',
  'details.hint.paketParcelLock.copy': 'To be able to use this parcel station, a TAN is required to pick up the shipment.',
  'details.hint.paketParcelLock.link-text': ' How it works',
  'details.hint.paketParcelLock.link-url': 'https://www.myhermes.de/service/paketstation/',

  // Media markkt
  'details.hint.parcel-shop.media-markt.copy': 'Seuls les colis de particuliers dont l\'étiquette d’envoi a été réglée en ligne (via myHermes.de ou l’application Hermes) peuvent être déposés dans ce PaketShop Hermes.',

  //paketParcelLock
  'callback-button.paketParcelLock.text': 'Select Paketstation',

  //paketParcelLock
  'details.title.paketParcelLock': 'Paketstation',

  'details.title': 'Point relais Hermes',
  'details.opening-hours': 'Horaires d\'ouvertures',
  'details.opening-hours-today': 'Horaires d\'ouverture aujourd\'hui',
  'details.parcelShopNumber': 'ID point relais',

  'details.benefits.shipping': 'Envoi de paquets et colis',
  'details.benefits.paketfuxx': 'Livraison voisinage',
  'details.benefits.redirect': 'Adresse de livraison alternatives',
  'details.benefits.pickup': 'Retrait avec procuration',
  'details.benefits.retours': 'Retours points relais',

  'details.on-holiday.note': 'À noter:',
  'details.on-holiday': 'Notre point relais est fermé du %from au %to.',
  'details.on-holiday.short': 'Vacances : du %from au %to',
  'services': 'Prestations',
  'callback-button.text': 'Valider le point relais',
  'callback-button.unavailable': 'Ce point relais ne peut malheureusement pas être sélectionné comme point relais souhaité',

  'filter.luggage': 'Dépôt de bagages',
  'filter.boxes': 'Emballages Hermès',
  'filter.time': 'Ouvert $day %time',

  'time-filter.closed': 'Ouvre à ',
  'time-filter.opened': "Ouvert jusqu'à ",
  'time-filter.from': ' et à partir de ',
  'time-filter.openedNextDay': 'Ouvre le lundi ',
  'time-filter.at': 'à',
  'time-filter.openedFilter': 'Ouvert ',

  'time-filter.openToday': 'Open today: ',
  'time-filter.clock': ' heure',

  'social-buttons.facebook': 'partager',
  'social-buttons.twitter': 'tweet',
  'social-buttons.whatsapp': 'partager',
  'social-buttons.email': 'e-mail',
  'social-buttons.print': 'imprimer',

  'shop-list.title': 'Les points relais proches de chez vous',
  'widget.headline': 'Chercher un point relais',
  'widget.input-placeholder': 'Adresse, code postal, ville',
  'widget.option-button': 'Autres options',
  'widget.submit-button': 'Chercher',
  'widget.open-on': 'Chercher',

  'legal': 'Aviso legal',
  'security': 'Advertencias de seguridad',
  'privacy': 'Protección de datos',
  'cookies': 'Cookies',

  'legal.url': 'https://www.hermesworld.com/int/credits/',
  'security.url': 'https://www.hermesworld.com/int/security-advice/',
  'privacy.url': 'https://www.hermesworld.com/int/data-protection/',
  'cookies.url': '#uc-corner-modal-show',

  'cookie.text': 'This website uses cookies to analyse our traffic.',
  'cookie.button-text': 'Ok',
  'cookie.link-text': 'Learn more',
  'cookie.link-url': 'https://www.hermesworld.com/int/data-protection/',

  //UserCentrics Cookie Consent
  'usercentrics.info': 'Die Anzeige von PaketShops in der Nähe basiert auf Google Maps. Mit dem Klick auf "Karte aktivieren" stimme ich der Datenfreigabe an Google Maps zu.',
  'usercentrics.button': 'Karte aktivieren',
  'usercentrics.privacy-text': 'Datenschutz',
  'usercentrics.privacy-url': 'https://www.myhermes.de/datenschutz/',
  'usercentrics.impressum-text': 'Impressum',
  'usercentrics.impressum-url': 'https://www.myhermes.de/impressum/'
};
